import { render, staticRenderFns } from "./NavBarHelp.vue?vue&type=template&id=4ab3b4e8&scoped=true"
import script from "./NavBarHelp.vue?vue&type=script&lang=ts&setup=true"
export * from "./NavBarHelp.vue?vue&type=script&lang=ts&setup=true"
import style0 from "./NavBarHelp.vue?vue&type=style&index=0&id=4ab3b4e8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ab3b4e8",
  null
  
)

export default component.exports